import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { ListBox } from "primereact/listbox";
//components
import Modal from "../../components/modal/Modal";
import Select from "../../components/input/Select";
//services
import { getUsers } from "../../services/GeneralRegistration/getUsers";
import { postBond } from "../../services/GeneralRegistration/postBond";
import { useAppContext } from "../../context/AppContext";

const MoveUsersModal = ({
  visible,
  setVisible,
  selectedCustomers,
  setSelectedCustomers,
}) => {
  const [loadingButton, setLoadingButton] = useState(null);
  const { control, reset, handleSubmit } = useForm();
  const { permissions } = useAppContext();
  const onSubmit = async (data) => {
    setLoadingButton(true);
    let obj;
    const usersId = selectedCustomers?.map((selected) => selected.id);
//    console.log(usersId);
    obj = {
      users_id: usersId,
      accessible_id: data.accessible_id,
    };
//    console.log(obj);
    const notification = toast.loading("Por favor aguarde...");

    try {
      await postBond(obj);
      toast.update(notification, {
        render: "Cadastro Movido com Sucesso",
        autoClose: 2000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível vincular, tente novamente!",
        autoClose: 2000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    }
    setLoadingButton(false);
    setVisible(false);
    setSelectedCustomers([]);
    reset();
  };

  const {
    data: users,
    refetch: refetchUsers,
    isLoading,
  } = useQuery({
    queryKey: ["users"],
    queryFn: () => getUsers(""),
    retry: false,
    enabled: !!permissions?.includes("6"),
  });

  const options = users?.map((customer) => ({
    value: customer.id,
    label: `${customer.name} - ${customer.doc}`,
  }));

  return (
    <Modal
      dynamicWidth={"75vw"}
      visible={visible}
      dynamicTitle={"Movimentação de Cadastros"}
      onHide={() => setVisible(false)}
      closable={true}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row align-items-center">
          <div className="col-md-5 mb-3 pb-3">
            <h5>Cadastros Selecionados</h5>
            <ListBox
              className={`w-full ${
                selectedCustomers.length === 1
                  ? "d-flex justify-content-center align-items-center"
                  : ""
              }`}
              options={selectedCustomers}
              optionLabel="name"
              optionValue="id"
              style={{ width: "100%" }}
              listStyle={{ maxHeight: "200px", overflowY: "auto" }}
              itemTemplate={(option) => (
                <div className="d-flex justify-content-between w-100">
                  <span>
                    {option.name} - {option.doc}
                  </span>
                </div>
              )}
            />
          </div>

          <div className="col-md-1 col-12 text-center mb-3">
            <i
              className="fa fa-solid fa-arrow-right d-none d-md-block"
              style={{ fontSize: "2em" }}
            ></i>
            <i
              className="fa fa-solid fa-arrow-down d-block d-md-none"
              style={{ fontSize: "2em" }}
            ></i>
          </div>

          <div className="col-md-3 col-12 pb-4">
            <label htmlFor="accessible_id" className="form-label">
              Mover Para
            </label>
            <Select
              isRequired={true}
              id="accessible_id"
              className={"mb-3"}
              name="accessible_id"
              control={control}
              options={options}
              disabled={isLoading}
            />
          </div>

          <div className="col-md-1 col-12 text-center mb-3">
            <i
              className="fa fa-solid fa-arrow-right d-none d-md-block"
              style={{ fontSize: "2em" }}
            ></i>
            <i
              className="fa fa-solid fa-arrow-down d-block d-md-none"
              style={{ fontSize: "2em" }}
            ></i>
          </div>

          <div className="col-md-1 col-12 pb-3 text-center">
            <Button
              type="submit"
              label="Mover"
              icon="pi pi-arrow-right"
              loading={loadingButton}
              autoFocus
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default MoveUsersModal;
